module.exports = __webpack_public_path__ + "static/media/ptsv.0de68ed4.svg";